<template>
  <vs-popup fullscreen id="loadingCancel" :active.sync="isLoading">
    <div class="flex align-center justify-center" style="height: 80vh">
      <vs-col>
        <vue-loading
          type="spin"
          color="#9a2411"
          :size="{ width: '100px', height: '100px' }"
        />
<!--        <vs-button class="mt-5" style="height: 50px; width: 200px" @click="cancelSale">İptal Et</vs-button>-->
      </vs-col>
    </div>
  </vs-popup>
</template>

<script>
import {VueLoading} from "vue-loading-template";

export default {
  methods: {
    cancelSale: async function () {
      fetch(process.env.VUE_APP_POS_API+"cancel", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        }
      }).then((response) => response.json())
        .then((data) => {
          if (data.statusCode == 200) {
            this.isLoading = false;
            this.$vs.notify({
              color: "success",
              title: "Ödeme iptal edildi.",
              text: ""
            });
          } else {
            this.isLoading = false;
            this.$vs.notify({
              color: "danger",
              title: data.message,
              text: ""
            });
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.$vs.notify({
            color: "danger",
            title: "İstek başarısız oldu. Tekrar Deneyiniz.",
            text: ""
          });
        });
    }
  }
  ,
  components: {
    VueLoading
  },
  computed: {
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
  },
};
</script>

<style>


#loadingCancel .vs-popup .vs-popup--header {
  display: none !important;
}

#loadingCancel .vs-popup .vs-popup--content {
  padding: 0 !important;
  /*height: 47vh;*/
}

#loadingCancel .vs-popup {
  background: transparent !important;
  box-shadow: none !important;
}

#loadingCancel input {
  font-size: 2rem !important;
  background: #f2f2f2 0% 0% no-repeat padding-box !important;
  text-align: center !important;
  padding: 0.5rem;
}
</style>
